import React, { useContext, useState, useTransition } from "react";
import "./Navbar.css";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoTwitter } from "react-icons/io5";
import { IoLogoInstagram } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa";
import { FaBehance } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";
import { Menu } from "../../Context/MenuOpen/MenuContext";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const {t , i18n} = useTranslation()
  const [openServe, setOpenServe] = useState(false);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const setIsOpen = menu.setIsOpen;

  return (
    <div style={{direction:"ltr"}}  className={`navbar ${isOpen && "open"}`}>
      <div className={`links`}>
  
        <NavLink
          onClick={() => {
            setIsOpen((prev) => !prev);
            setOpenServe(false)
          }}
          to="/"
          className="link"
        >
          {t("Home")}
        </NavLink>
        <button onClick={() => setOpenServe((prev) => !prev)} className="link">
          {t("Services")}
        </button>
        <div
          className="services-list m-0 flex flex-col justify-between items-start  overflow-hidden transition-all duration-500 ease-in-out"
          style={{ height: openServe ? "160px" : "0px" }}
        >
          <NavLink
            onClick={() => {
              setIsOpen((prev) => !prev);
              setOpenServe((prev) => !prev);
            }}
            className="link"
            to="/media-production"
          >
            {t("Media Production")}
          </NavLink>
          <NavLink
            onClick={() => {
              setIsOpen((prev) => !prev);
              setOpenServe((prev) => !prev);
            }}
            className="link"
            to="/education"
          >
          {t("Education Services")}
          </NavLink>
          <NavLink
            onClick={() => {
              setIsOpen((prev) => !prev);
              setOpenServe((prev) => !prev);
            }}
            className="link"
            to="/web-solution"
          >
            {t("Web Development")}
          </NavLink>
      
          <NavLink
            onClick={() => {
              setIsOpen((prev) => !prev);
              setOpenServe((prev) => !prev);
            }}
            className="link"
            to="/digital-marketing"
          >
          {t("Digital Marketing")}
          </NavLink>
          <NavLink
            onClick={() => {
              setIsOpen((prev) => !prev);
              setOpenServe((prev) => !prev);
            }}
            className="link"
            to="/event-management"
          >
          {t("Event Management")}
          </NavLink>
        </div>
        <NavLink
          onClick={() => {
            setIsOpen((prev) => !prev);
            setOpenServe(false);
          }}
          to="/blogs"
          className="link"
        >
          {t("Blogs")}
        </NavLink>
        <NavLink
          onClick={() => {
            setIsOpen((prev) => !prev);
            setOpenServe(false);
          }}
          to="/portfolio"
          className="link"
        >
          {t("Portfolio")}
        </NavLink>
        <NavLink
          onClick={() => {
            setIsOpen((prev) => !prev);
            setOpenServe((prev) => !prev);
          }}
          to="/contact"
          className="link"
        >
          {t("Contact")}
        </NavLink>
      </div>
      <div className="social-links">
        <div className="icon-container">
          <FaFacebookF className="icon" />
        </div>
        <div className="icon-container">
          <IoLogoTwitter className="icon" />
        </div>
        <div className="icon-container">
          <IoLogoInstagram className="icon" />
        </div>
        <div className="icon-container">
          <FaLinkedinIn className="icon" />
        </div>
        <div className="icon-container">
          <FaBehance className="icon" />
        </div>
      </div>
      <div className="contact mt-4">
        <div className="flex items-center gap-3 mt-2">
          <IoCallOutline className="icon" />
          <span>(+20)1005400514</span>
        </div>
        {/* <div className="flex items-center gap-3 mt-2">
          <IoCallOutline className="icon" />
          <span>+201006024005</span>
        </div> */}
        <div className="flex items-center gap-3 mt-2">
          <AiOutlineMail className="icon" />
          <span>Info@Sunmedagency.com</span>
        </div>
      </div>
      {isOpen && (
        <div className="close" onClick={() => setIsOpen((prev) => !prev)}>
          <IoMdClose className="icon" />
        </div>
      )}
    </div>
  );
};

export default Navbar;
